import React, { useState, useRef, useCallback, useEffect } from 'react';

// Lightweight before/after slider. Drag to reveal the second image.
export default function ImageCompareSlider({ imageA, imageB, labelA, labelB }) {
  const containerRef = useRef(null);
  const [position, setPosition] = useState(50);
  const [isDragging, setIsDragging] = useState(false);
  const [width, setWidth] = useState(1000);

  useEffect(() => {
    const measure = () => {
      if (containerRef.current) setWidth(containerRef.current.clientWidth);
    };
    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, []);

  const updatePosition = useCallback((clientX) => {
    if (!containerRef.current) return;
    const rect = containerRef.current.getBoundingClientRect();
    const x = clientX - rect.left;
    setPosition(Math.max(2, Math.min(98, (x / rect.width) * 100)));
  }, []);

  return (
    <div
      ref={containerRef}
      className="relative w-full overflow-hidden select-none cursor-col-resize"
      style={{ aspectRatio: '16/10' }}
      onMouseDown={(e) => { e.preventDefault(); setIsDragging(true); updatePosition(e.clientX); }}
      onMouseMove={(e) => isDragging && updatePosition(e.clientX)}
      onMouseUp={() => setIsDragging(false)}
      onMouseLeave={() => setIsDragging(false)}
      onTouchMove={(e) => updatePosition(e.touches[0].clientX)}
      data-testid="image-compare-slider"
    >
      <img src={imageB} alt={labelB || 'After'} className="absolute inset-0 w-full h-full object-cover" draggable={false} />
      <div className="absolute inset-0 overflow-hidden" style={{ width: `${position}%` }}>
        <img src={imageA} alt={labelA || 'Before'} className="absolute inset-0 w-full h-full object-cover" style={{ width: `${width}px`, maxWidth: 'none' }} draggable={false} />
      </div>
      <div className="absolute top-0 bottom-0 z-10" style={{ left: `${position}%`, transform: 'translateX(-50%)' }}>
        <div className="w-0.5 h-full bg-white shadow-lg" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white shadow-xl flex items-center justify-center cursor-col-resize">
          <svg width="16" height="16" viewBox="0 0 16 16" className="text-gray-700">
            <path d="M5 3L2 8L5 13" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M11 3L14 8L11 13" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
      </div>
      <span className="absolute top-3 left-3 px-3 py-1 bg-black/70 text-white text-xs font-bold rounded-full z-20">{labelA || 'BEFORE'}</span>
      <span className="absolute top-3 right-3 px-3 py-1 text-white text-xs font-bold rounded-full z-20" style={{ background: '#D47739' }}>{labelB || 'AFTER'}</span>
    </div>
  );
}
